const share = (message: string, url: string) => {
    // TODO: Special handling for non-native sharing
    console.log(url, message);
};

export { share };